module.exports = __webpack_public_path__ + "media/images/press_kit/norwegian_cruise_line_holdings/login/1_ncl-ed80bfb43461c36509511af9539d5915.png";